import { Link } from "react-router-dom";
import { SEGMENT_LIST } from "../../lib/content";

const cols = [
  {
    title: "Why Partner",
    links: [
      { label: "The Opportunity", to: "/why-partner#the-opportunity" },
      { label: "Why Partner With Us", to: "/why-partner#why-us" },
      { label: "The Economics", to: "/why-partner#the-economics" },
    ],
  },
  {
    title: "Who We Serve",
    links: SEGMENT_LIST.map((s) => ({ label: s.nav, to: `/who-we-serve/${s.slug}` })),
  },
  {
    title: "How It Works",
    links: [
      { label: "Our Process", to: "/how-it-works#our-process" },
      { label: "Integration Models", to: "/how-it-works#integration-models" },
    ],
  },
  {
    title: "Get Started",
    links: [
      { label: "Become a Partner", to: "/become-a-partner" },
      { label: "Company", to: "/company" },
      { label: "Contact", to: "/become-a-partner" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#EDEFF7] border-t border-[#D3D6E0]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-4">
              <img src="/logo-communitytax.webp" alt="Community Tax" className="w-44 h-auto" />
            </Link>
            <p className="text-sm text-[#40424D] leading-relaxed max-w-xs">
              Embedded tax debt resolution infrastructure for financial, tax, and legal ecosystems.
            </p>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="font-display font-semibold text-[#1E1E24] text-sm mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-[#40424D] hover:text-[#0262B4] transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-[#D3D6E0] flex flex-col md:flex-row justify-between gap-4">
          <p className="text-sm text-[#40424D]">
            © {new Date().getFullYear()} Community Tax, LLC. All rights reserved.
          </p>
          <p className="text-sm text-[#40424D]">Nationwide coverage · English & Spanish servicing · 48 states</p>
        </div>
      </div>
    </footer>
  );
}
